"use strict";
// Param, result and chunk shapes for gateway.* methods (defined in gateway.ts); type aliases, so params fit RpcWireParams.
Object.defineProperty(exports, "__esModule", { value: true });
